import { motion } from "framer-motion";
import { PROCESS } from "@/data/studio";
import { Section, SectionHeading } from "@/components/shared/Primitives";
import { revealStaggered, VIEW_NEAR } from "@/components/shared/motion";

export default function HowWeWork() {
  return (
    <Section id="process" testId="process-section">
      <SectionHeading
        overline="How We Work"
        title="Five stages, one creative direction."
        lead="No hand-offs between disciplines — the same team carries an idea from the first question to the final frame."
      />
      <div className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-5 lg:gap-4">
        {PROCESS.map((stage, i) => (
          <motion.article
            key={stage.id}
            data-testid={`process-stage-${stage.id}`}
            variants={revealStaggered}
            initial="hidden"
            whileInView="show"
            viewport={VIEW_NEAR}
            custom={i * 0.1}
            className="group relative overflow-hidden rounded-2xl border border-white/10 bg-[#12141C]/45 p-7 backdrop-blur-xl transition-colors duration-500 hover:border-[#06B6D4]/40"
          >
            <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#06B6D4]/60 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
            <span className="text-outline font-display block text-4xl font-black leading-none md:text-5xl">
              {stage.id}
            </span>
            <h3 className="font-display mt-5 text-base font-semibold uppercase tracking-[0.15em] text-[#F4F6FB] md:text-lg">
              {stage.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-[#F4F6FB]/55">{stage.content}</p>
          </motion.article>
        ))}
      </div>
    </Section>
  );
}
